import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'

/** /settings has no page of its own: open the selected company's settings, or the user's own without one. */
const SettingsRootRedirect: React.FC = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  return <Navigate to={companyId ? '/settings/company' : '/settings/user'} replace />
}

export default SettingsRootRedirect
